import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { AlarmListParams } from '../../apis/client-side/alarm/type';

export const alarmQueryKeys = createQueryKeys('alarm', {
  fetchAlarmList: (fetchAlarmList: AlarmListParams) => [fetchAlarmList],
  fetchAlarmDelete: () => ['alarmDelete'],
  fetchAlarmIsRead: () => ['alarmIsRead'],
});
